import app from "../scenes/app/state/reducer";
import accountReducer from "../scenes/account/state/reducer";
import uploadReducer from "../scenes/components/upload/state/reducer";

export default {
  app,
  accountReducer,
  uploadReducer
};
